define(
({
  "load_error": "Load Error",
  "description": "A request did not complete correctly. You should make sure your order is saved then refresh this page."
})
);
